import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import { IMikeTheme } from './types';
import { DHITypographyV516 } from './typography';
import dhiPalette from './pallete';
import dhiOverrides from './override';

const defaultTheme = createTheme();

export const DHIThemeV516: IMikeTheme = createTheme(
  deepmerge(defaultTheme, {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1300, 
        xl: 1500,
      },
    },
    typography: DHITypographyV516,
    palette: dhiPalette,
    components: dhiOverrides,
  })
)
